<div class="w-full flex justify-center">
  <div class="flex flex-col max-w-[1400px] w-full">
    <zaeper-page-layout [pageLayout]="ePageLayout.CARDS"
                        [title]="'Widget bearbeiten'"
    >
      <div class="flex flex-col gap-4">
        <div class="w-full text-right">
          <p-button [rounded]="true" [outlined]="true">Löschen</p-button>
        </div>

        <div class="relative flex flex-row gap-6">
          <zaeper-card styleClass="h-full">
            <div class="flex flex-col gap-4 w-full">
              <div class="text-xl">Informationen</div>
              <zaeper-card>
                <zaeper-input-group [inputOptions]="propertiesInputGroup"/>
              </zaeper-card>
              <zaeper-card>
                <div class="flex flex-col gap-4">
                  <div class="text-xl">Beschreibung</div>
                  <div class="flex flex-col gap-4">
                    <zaeper-tab-navigation [mode]="ETabNavigationMode.LIGHT" [tabs]="detailTabs">
                      <ng-template zTemplate="afterNavigation">
                        <p-button icon="pi pi-plus" [rounded]="true" severity="secondary"/>
                      </ng-template>

                      <ng-template zTemplate="tab">
                        <zaeper-input-group [inputOptions]="localizedInfoInputGroup"/>
                      </ng-template>
                    </zaeper-tab-navigation>
                  </div>
                </div>
              </zaeper-card>
              <zaeper-card>
                <zaeper-input-group [inputOptions]="accessControlInputGroup"/>
              </zaeper-card>
            </div>
          </zaeper-card>
          <zaeper-card styleClass="h-full">
            <div class="flex flex-col gap-4">
              <div class="text-xl">Darstellung</div>
              <zaeper-card>
                <div class="flex flex-col gap-4">
                  <div class="text-xl">Store</div>
                  <div class="relative">
                    <app-application-overview-item [application]="widget$()!"/>
                    <div class="absolute top-2 right-2">
                      <input #uploadTitleImageInput accept=".jpg, .jpeg, .png" class="hidden" type="file"
                             (change)="uploadTitleImage($event)"/>
                      <p-button severity="secondary" icon="pi pi-upload" [rounded]="true"
                                (onClick)="uploadTitleImageInput.click()"/>
                    </div>
                  </div>
                </div>
              </zaeper-card>

              <zaeper-card>
                <div class="flex flex-col gap-4">
                  <div class="text-xl">Icon</div>
                  <div class="flex col w-full h-full rounded overflow-hidden">
                    <div class="grid place-content-center relative px-6 py-4 isolate w-full">
                      <img ngSrc="/images/background.jpg"
                           class="absolute -z-1 top-0 left-0 w-full h-full object-cover brightness-50" fill
                           alt="Receiver preview light background"/>
                      <div class="flex flex-col gap-3 items-center">
                        <div class="relative h-[75px] w-[75px] rounded-xl overflow-hidden drop-shadow-lg">
                          <img [ngSrc]="widget$()?.lightIconUrl ?? ''"
                               fill alt="Light icon preview" class="object-cover"/>
                        </div>
                        <span
                          class="text-white drop-shadow-md max-w-[120px] overflow-hidden whitespace-nowrap overflow-ellipsis">{{ widgetForm.controls["name"].value }}</span>
                      </div>

                      <div class="absolute top-2 right-2">
                        <input #uploadLightIconImageInput accept=".jpg, .jpeg, .png" class="hidden" type="file"
                               (change)="uploadIconImage($event, 'light')"/>
                        <p-button severity="secondary" icon="pi pi-upload"
                                  (onClick)="uploadLightIconImageInput.click()" [rounded]="true"/>
                      </div>
                    </div>

                    <div class="grid place-content-center relative px-6 py-4 isolate w-full">
                      <img ngSrc="/images/background.jpg"
                           class="absolute -z-1 top-0 left-0 w-full h-full object-cover" fill
                           alt="Receiver preview dark background"/>
                      <div class="flex flex-col gap-3 items-center">
                        <div class="relative h-[75px] w-[75px] rounded-xl overflow-hidden drop-shadow-lg">
                          <img [ngSrc]="widget$()?.darkIconUrl ?? ''"
                               fill alt="Dark icon preview" class="object-cover"/>
                        </div>
                        <span
                          class="text-white drop-shadow-[0_0_1px_rgba(0,0,0,2)] max-w-[120px] overflow-hidden whitespace-nowrap overflow-ellipsis">{{ widgetForm.controls["name"].value }}</span>
                      </div>

                      <div class="absolute top-2 right-2">
                        <input #uploadDarkIconImageInput accept=".jpg, .jpeg, .png" class="hidden" type="file"
                               (change)="uploadIconImage($event, 'dark')"/>
                        <p-button severity="secondary" icon="pi pi-upload"
                                  (onClick)="uploadDarkIconImageInput.click()" [rounded]="true"/>
                      </div>
                    </div>
                  </div>
                </div>
              </zaeper-card>
            </div>
          </zaeper-card>
        </div>

        <zaeper-card>
          <div class="flex flex-col gap-4">
            <div class="text-xl">Releases</div>
            <p-table [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20,50]"
                     [totalRecords]="0" [lazy]="true" (onLazyLoad)="lazyLoadTable($event)"
                     [loading]="false" [showLoader]="false" [value]="widgetVersions$()?.records ?? []"
                     [tableStyle]="{ 'min-width': '50rem' }">
              <ng-template pTemplate="loadingbody" let-columns="columns">
                @for (i of [ 1 ]; track i) {
                  <tr>
                    <td>
                      <p-skeleton height="2rem"></p-skeleton>
                    </td>
                    <td>
                      <p-skeleton height="2rem"></p-skeleton>
                    </td>
                    <td>
                      <p-skeleton height="2rem"></p-skeleton>
                    </td>
                    <td>
                      <p-skeleton height="2rem"></p-skeleton>
                    </td>
                  </tr>
                }
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="5" class="text-center">
                    Keine Einträge gefunden
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th>#</th>
                  <th>Version</th>
                  <th>Status</th>
                  <th class="w-1/2">Changelog</th>
                  <th>Aktionen</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-widgetVersion let-i="rowIndex">
                <tr class="align-top">
                  <td>{{ i + 1 }}</td>
                  <td><strong>{{ widgetVersion.versionNumber }}</strong></td>
                  <td>
                    Nicht veröffentlicht
                  </td>
                  <td [ngClass]="{'text-surface-400 dark:text-surface-500': !widgetVersion.changelog}">
                    <i [innerHTML]="(widgetVersion.changelog | sanitizeHtml) ?? 'Keine Beschreibung vorhanden'"></i></td>
                  <td>
                    <div class="flex gap-2 justify-end">
                      <p-button [outlined]="true" [rounded]="true" icon="pi pi-cog" [routerLink]="['version', widgetVersion.id]" />
                      <p-button [outlined]="true" [rounded]="true" icon="pi pi-trash" severity="danger"/>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </zaeper-card>

        <div class="sticky flex row gap-2 bottom-0 bg-surface-0 dark:bg-surface-900 p-4 justify-between shadow w-full">
          <p-button (onClick)="discardChanges()" [outlined]="true" [rounded]="true">Verwerfen</p-button>
          <div class="flex flex-row gap-2">
            <p-button (onClick)="update()" [outlined]="true" [rounded]="true">Änderungen speichern</p-button>
            <p-button (onClick)="publish()" [rounded]="true">Zur Überprüfung abschicken</p-button>
          </div>
        </div>
      </div>
    </zaeper-page-layout>
  </div>
</div>
